/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import './Footer.css';  // Assuming you have a CSS file for styling the footer

function Footer() {
  return (
    <footer className="site-footer alt-footer">
      <div className="footer-inner">
        <div className="footer-logo">
          <img className="logo" src={process.env.PUBLIC_URL + '/assets/B-EATS-logo.png'} alt="Beats Rest Logo" />
        </div>

        <div className="footer-details">
          <p className="footer-hours">
            <strong>Horarios:</strong><br />
            D-J 4:00 pm – 12:00 am<br />
            V-S 4:00 pm – 3:00 am
          </p>
          <p className="footer-address">
            <strong>Dirección:</strong><br />
            Plaza roja 3er piso, Calle José María Narvaez #1029 Blanco y Cuellar,<br />
            Guadalajara, Jalisco 44730
          </p>
          <div className="footer-socials">
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.tiktok.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Beats Rest. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
